import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { tagsOf } from "./calc";
import { TAG_COLORS, tagLabels } from "./labels";

/** Position kind tags of an offer item (or of a preview item passed as { gaeb: item }). */
const GaebTags = ({ item }) => {
  const { t } = useTranslation("dashboard");
  const labels = tagLabels(t);
  const tags = tagsOf(item);
  if (!tags.length) return null;
  return (
    <span className="gaeb-tags">
      {tags.map(tag => (
        <Tag key={tag} color={TAG_COLORS[tag]} bordered={false}>
          {labels[tag]}
        </Tag>
      ))}
    </span>
  );
};

export default GaebTags;
